import { jsonToHTML } from '@Utils/cms-rte';
import { getImage } from '@Utils/cms';

function adapterBannerApp(data) {
  if (!data) {
    return undefined;
  }

  const title = jsonToHTML(data.banner_app_title, { inline: true });
  const content = jsonToHTML(data.banner_app_text, { inline: true });
  const {
    banner_app_link_apple: appleLink,
    banner_app_link_apple_image: appleImg,
    banner_app_link_android: androidLink,
    banner_app_link_android_image: androidImg,
  } = data;

  const img = getImage(data.banner_app_media);
  let appleAppStore, googlePlay;

  if (appleImg && appleLink) {
    appleAppStore = {
      attributes: {
        external: true,
        href: appleLink,
      },
      img: appleImg.url,
      label: appleImg.title,
    };
  }

  if (androidImg && androidLink) {
    googlePlay = {
      attributes: {
        external: true,
        href: androidLink,
      },
      img: androidImg.url,
      label: androidImg.title,
    };
  }

  return {
    appleAppStore,
    content,
    googlePlay,
    img,
    title,
  };
}

export { adapterBannerApp };
